module.exports = __webpack_public_path__ + "img/logo1.762d86c3.jpg";